import { parseSiteCluster, parseThresholdMap } from './countReviewFlags.js';

/**
 * Distinct site clusters for admin threshold UI.
 * extras.cluster first, then site.cluster; dedupe case-insensitively; preserve first-seen label.
 * Also includes keys from existingMap (e.g. saved thresholds for clusters no longer on sites).
 * @returns {{ key: string, label: string }[]}
 */
export function discoverSiteClusters(sites, existingMap = {}) {
  const byKey = new Map();
  for (const site of sites || []) {
    const { key, label } = parseSiteCluster(site);
    if (!key || byKey.has(key)) continue;
    byKey.set(key, { key, label: label || key });
  }
  const parsedExisting = parseThresholdMap(existingMap);
  for (const key of Object.keys(parsedExisting)) {
    if (!byKey.has(key)) {
      byKey.set(key, { key, label: key });
    }
  }
  return [...byKey.values()].sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
  );
}

/** Build normalized threshold map from string inputs keyed by cluster key. Invalid/blank omitted. */
export function buildThresholdMapFromInputs(inputs, clusters) {
  const out = {};
  for (const cluster of clusters || []) {
    const raw = inputs && inputs[cluster.key];
    if (raw === '' || raw === null || raw === undefined) continue;
    const n = parseFloat(String(raw));
    if (Number.isNaN(n) || n < 0) {
      return { error: `Threshold for "${cluster.label}" must be a non-negative number` };
    }
    out[cluster.key] = n;
  }
  return { value: out };
}

/** Map stored threshold object to string inputs for form fields. */
export function thresholdMapToInputs(map, clusters) {
  const parsed = parseThresholdMap(map);
  const inputs = {};
  for (const cluster of clusters || []) {
    inputs[cluster.key] =
      parsed[cluster.key] != null && parsed[cluster.key] !== '' ? String(parsed[cluster.key]) : '';
  }
  return inputs;
}
